import { render, staticRenderFns } from "./ClosedOrders.vue?vue&type=template&id=4118f765&scoped=true&"
import script from "./ClosedOrders.vue?vue&type=script&lang=js&"
export * from "./ClosedOrders.vue?vue&type=script&lang=js&"
import style0 from "./ClosedOrders.vue?vue&type=style&index=0&id=4118f765&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4118f765",
  null
  
)

export default component.exports